import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { KeycloakService } from 'keycloak-angular';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { Container } from '../../containers/container';
import { Tenant } from '../../entities/tenant/tenant';
import { LoadingService } from '../../services/loading.service';
import { RolesService } from '../../services/roles/roles.service';
import { TenantsService } from '../../services/tenants/tenants.service';
import { ToastService } from '../../services/toast/toast.service';
import { CompanyDialogComponent } from '../company-dialog/company-dialog.component';
import { EditDialogService } from '../editDialog/editDialogService';
import * as fromGraphQl from './graphql';

@Component({
  selector: 'app-company-view',
  templateUrl: './company-view.component.html',
  styleUrls: ['./company-view.component.scss']
})
export class CompanyViewComponent
extends Container<fromGraphQl.TenantQueryResponse>
  implements OnInit, OnDestroy
 {

  dialogRef: DynamicDialogRef | undefined;

  public tenant: Tenant;
  public id: string;
  public routeSubscription: Subscription;


  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public loadingService: LoadingService,
    private rolesService: RolesService,
    private keycloakAngular: KeycloakService,
    apollo: Apollo,
    public dialogService: EditDialogService,
    @Inject('env') environment : any,
    private tenantService: TenantsService,
    private toastService: ToastService
  ) {
    super(apollo, loadingService, fromGraphQl.TENANT_QUERY, environment);
   }

  ngOnInit(): void {
    this.id = this.keycloakAngular.getKeycloakInstance()
      ? (this.keycloakAngular.getKeycloakInstance()?.idTokenParsed as any)['tenant_id'] : undefined;
    if (this.id) {
      this.subscribeToQuery({
        id: this.id,
      });
    }

  }

  handleSubscriptionResult(data: fromGraphQl.TenantQueryResponse): void {
    this.loadingService.setLoading(false);
    if (data.tenant) {
      this.tenant = new Tenant(data.tenant);
    }
  }

  editCompany(): void {
    this.dialogRef = this.dialogService.open(CompanyDialogComponent, {
      header: 'core.companyViewComponent.editDialog.header',
      data: this.tenant
    });
    this.dialogRef.onClose.subscribe((result) => {
      // result is true or false, indiciating if it should refetch
      if(result){
        this.queryRef.refetch();
      }
    });
  }

  getVatType(value: any): string {
    return this.tenantService.getVatTypeName(value);
  }
  
  copyToClipboard(stringToCopy: string): void {
    navigator.clipboard.writeText(stringToCopy).then(() => {
      this.toastService.addToastWithMessage('core.companyViewComponent.toast.tenantIdCopied');
    }).catch(err => {
      // error
    });
  }
}
